module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form text-left"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("編號")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n        " + _vm._s(_vm.memberInfo.user_no) + "\n      ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("ID")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.memberInfo.shopper_id) + "\n        ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("暱稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.memberInfo.nickname) + "\n        ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("登入類型")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.memberInfo.create_account_type == 1) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/phone.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 2) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/fb.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 3) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/google.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 4) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "src": "/static/img/icon/line.png"
    }
  })]) : _vm._e(), (_vm.memberInfo.create_account_owner_type == 2 && _vm.memberInfo.create_account_type == 4) ? _c('span', [_vm._v("(" + _vm._s(_vm.memberInfo.create_account_owner_brand_name) + ")")]) : (_vm.memberInfo.create_account_owner_type == 1 && _vm.memberInfo.create_account_type == 4) ? _c('span', [_vm._v("(你訂)")]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 5) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/jkos.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 6) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/car.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 7) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/existing-member.png"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.memberInfo.sex) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("性別")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.memberInfo.sex == 1) ? _c('span', {
    staticClass: "text-blue"
  }, [_c('i', {
    staticClass: "fa fa-male",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.sex == 2) ? _c('span', {
    staticClass: "text-red"
  }, [_c('i', {
    staticClass: "fa fa-female",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.email) ? _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("信箱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.memberInfo.email) + "\n        ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.birth) ? _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("生日")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.memberInfo.birth) + "\n        ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("手機")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberInfo.phone),
      expression: "memberInfo.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "10",
      "id": "phone"
    },
    domProps: {
      "value": (_vm.memberInfo.phone)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPhone()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.memberInfo, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.memberInfo.is_phone_valid) ? _c('div', {
    staticClass: "input-group mb-3",
    staticStyle: {
      "display": "flex"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.v_code),
      expression: "v_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.v_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.v_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.v_code),
      expression: "v_code",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticClass: "btn btn-secondary m-l-5 m-y-5",
    class: {
      'btn-success': _vm.v_code !== ''
    },
    attrs: {
      "disabled": _vm.v_code === ''
    }
  }, [_vm._v("複製")])])]) : _vm._e(), _vm._v(" "), (!_vm.memberInfo.is_phone_valid) ? _c('span', [_c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          停權\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberInfo.is_suspend),
      expression: "memberInfo.is_suspend"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.memberInfo, "is_suspend", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("正常")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("停權")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.memberInfo.create_account_type != 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            手機驗證\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberInfo.is_phone_valid),
      expression: "memberInfo.is_phone_valid"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.memberInfo, "is_phone_valid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("通過")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未通過")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          " + _vm._s(_vm.memberInfo.create_account_type === 1 ? '手機驗證' : '開通') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberInfo.is_active),
      expression: "memberInfo.is_active"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.memberInfo, "is_active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("啟動")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("未啟動")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            每日交易金額上限\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberInfo.daily_trade_limit),
      expression: "memberInfo.daily_trade_limit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.memberInfo.daily_trade_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.memberInfo, "daily_trade_limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            居住地\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_vm._v("\n            " + _vm._s(_vm.cityAreaName(_vm.citySelect, _vm.areaSelect)) + "\n          ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            地址\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.memberInfo.address_short),
      expression: "memberInfo.address_short",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "請輸入地址",
      "type": "text"
    },
    domProps: {
      "value": (_vm.memberInfo.address_short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.memberInfo, "address_short", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.memberInfo.create_account_type === 7 && !_vm.memberInfo.main_shopper_id) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            備註\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberInfo.remark),
      expression: "memberInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "請輸入備註",
      "type": "text"
    },
    domProps: {
      "value": (_vm.memberInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.memberInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.reMessageVerityOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.reMessageWrongOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.sendMessageOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#reMessageVerityModal"
    }
  }, [_vm._v("\n              簡訊驗證次數歸零\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#reMessageWrongModal"
    }
  }, [_vm._v("\n              驗證錯誤次數歸零\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#sendMessageModal"
    }
  }, [_vm._v("\n              產生驗證碼\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-466b3585"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Member/Temp/MemberFormTemp.vue
// module id = 2398
// module chunks = 1